import {
  KEAElement,
  KEAGraph,
  KEALink,
  keaNamespace,
  KEAUMLClass,
  LinkType,
  MarkerPosition,
  MarkerType,
} from "@kea-mod/jointjs";
import { LinkConfiguration } from "shared/LinkConfiguration";
import { TemplateConfiguration } from "./TemplateConfiguration";

let current_y = 10;

const class1 = new KEAUMLClass();
class1.position(20, current_y);
class1.setClassIdentifier("Class");
class1.setClassName("");
current_y += 180;

const link1 = new KEALink();
link1.source({ x: 20, y: current_y });
link1.target({ x: 200, y: current_y });
link1.setDasharray(LinkType.SOLID);
link1.setMarker(MarkerPosition.SOURCE_MARKER, MarkerType.NONE);
link1.setMarker(MarkerPosition.TARGET_MARKER, MarkerType.NONE);
current_y += 40;

const link2 = new KEALink();
link2.source({ x: 20, y: current_y });
link2.target({ x: 200, y: current_y });
link2.setDasharray(LinkType.SOLID);
link2.setMarker(MarkerPosition.SOURCE_MARKER, MarkerType.NONE);
link2.setMarker(MarkerPosition.TARGET_MARKER, MarkerType.ARROW);
current_y += 40;

const link3 = new KEALink();
link3.source({ x: 20, y: current_y });
link3.target({ x: 200, y: current_y });
link3.setDasharray(LinkType.SOLID);
link3.setMarker(MarkerPosition.SOURCE_MARKER, MarkerType.NONE);
link3.setMarker(MarkerPosition.TARGET_MARKER, MarkerType.ARROW_EMPTY);
current_y += 40;

const link4 = new KEALink();
link4.source({ x: 20, y: current_y });
link4.target({ x: 200, y: current_y });
link4.setDasharray(LinkType.SOLID);
link4.setMarker(MarkerPosition.SOURCE_MARKER, MarkerType.NONE);
link4.setMarker(MarkerPosition.TARGET_MARKER, MarkerType.DIAMOND_EMPTY);
current_y += 40;

const link5 = new KEALink();
link5.source({ x: 20, y: current_y });
link5.target({ x: 200, y: current_y });
link5.setDasharray(LinkType.SOLID);
link5.setMarker(MarkerPosition.SOURCE_MARKER, MarkerType.NONE);
link5.setMarker(MarkerPosition.TARGET_MARKER, MarkerType.DIAMOND_FILLED);
current_y += 40;

const link6 = new KEALink();
link6.source({ x: 20, y: current_y });
link6.target({ x: 200, y: current_y });
link6.setDasharray(LinkType.DASHED);
link6.setMarker(MarkerPosition.SOURCE_MARKER, MarkerType.NONE);
link6.setMarker(MarkerPosition.TARGET_MARKER, MarkerType.ARROW_EMPTY);
current_y += 40;

const link7 = new KEALink();
link7.source({ x: 20, y: current_y });
link7.target({ x: 200, y: current_y });
link7.setDasharray(LinkType.DASHED);
link7.setMarker(MarkerPosition.SOURCE_MARKER, MarkerType.NONE);
link7.setMarker(MarkerPosition.TARGET_MARKER, MarkerType.ARROW);
current_y += 40;

const class2 = new KEAUMLClass();
class2.position(20, current_y);
class2.setClassIdentifier("Interface");
class2.setClassName("");
current_y += 180;

const class3 = new KEAUMLClass();
class3.position(20, current_y);
class3.setClassIdentifier("Enumeration");
class3.setClassName("");
current_y += 180;

let defaultLink = link1.clone();

export const getUMLClassConfiguration = (): Array<KEAElement | KEALink> => {
  return [class1, link1, link2, link3, link4, link5, link6, link7, class2, class3];
};

export const getUMLClassMarkup = (): TemplateConfiguration => {
  const conf: LinkConfiguration = {
    addLabelEnabled: true,
    editPathTypeEnabled: true,
    editSourceMarkerEnabled: true,
    editTargetMarkerEnabled: true,
  };
  const graph = new KEAGraph({}, { cellNamespace: keaNamespace });
  graph.addCells(getUMLClassConfiguration());
  return new TemplateConfiguration(
    graph.toJSON(),
    0.6,
    () => {
      return defaultLink;
    },
    conf,
  );
};
